module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/italic-636e15d7e854b6705c6b925af1288b30.svg";